export default __webpack_public_path__ + "static/media/section_and_category_merchandise.308cc598.svg";